import { BankRegistrationGuide } from './BankRegistrationGuide';
import {
  GATEWAY_NUMBER_DISPLAY,
  WOORI_COMPLETE_REGISTRATION_STEPS,
  WOORI_NOTIFY_OPTIONS,
  WOORI_REQUEST_CODE_STEPS,
} from './wooriGuide';

interface Props {
  authCode: string | null;
  codeRemainingSec: number | null;
  registered: boolean;
  onCancel: () => void;
  onComplete: () => void;
}

export function WooriRegistrationGuide(props: Props) {
  return (
    <BankRegistrationGuide
      {...props}
      bankAppLabel="우리은행 모바일 앱(우리 WON뱅킹)"
      authCodeLength={4}
      requestCodeSteps={WOORI_REQUEST_CODE_STEPS}
      completeRegistrationSteps={WOORI_COMPLETE_REGISTRATION_STEPS}
      notifyOptions={WOORI_NOTIFY_OPTIONS}
      awaitingCodeMessage="6단계에서 번호를 입력한 뒤 [인증요청]을 누르면 이곳에 자동으로 표시돼요."
      gatewayNumber={GATEWAY_NUMBER_DISPLAY}
    />
  );
}
